import { render, staticRenderFns } from "./ModernPrimaryNavigation.vue?vue&type=template&id=9d86b766&"
import script from "./ModernPrimaryNavigation.vue?vue&type=script&lang=js&"
export * from "./ModernPrimaryNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports